interface HandmadeBlock {
  title: string
  text: string
}

interface HandmadeSectionProps {
  image: string
  title: string
  blocks: HandmadeBlock[]
}

export default function HandmadeSection({
  image,
  title,
  blocks,
}: HandmadeSectionProps) {
  return (
    <section id="about" className="py-16 md:py-24 bg-light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-contrast mb-12 md:mb-16">
          {title}
        </h2>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/2">
            <img
              src={image}
              alt=""
              className="w-full h-auto rounded-lg"
            />
          </div>

          <div className="lg:w-1/2 space-y-10">
            {blocks.map((block) => (
              <div key={block.title}>
                <h3 className="text-xl md:text-2xl font-bold text-contrast mb-3">
                  {block.title}
                </h3>
                <p className="text-content leading-relaxed">{block.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
